import * as React from 'react';
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Backdrop,
  Button,
  CircularProgress,
  IconButton,
  Tooltip,
  Box,
  TextField,
  Pagination,
  FormControl,
  MenuItem,
  Checkbox,
  InputLabel,
  Select,
  TableSortLabel,
  Toolbar,
  Typography,
  SelectChangeEvent,
  Autocomplete,
  Tabs,
  Tab,
} from '@mui/material';
import HttpService from '../../../hooks/Https-services';
import PAGE_ROUTES, {
  API_ROUTES,
  ROLE_MAP_filter,
} from '../../../utils/constant';
import { useBoolean } from '../../../hooks/use-boolean';
import usePopover from '../../../hooks/use-popover';
import { ConfirmDialog, StatusDialog } from '../../../components/custom-dialog';
import Iconify from '../../../components/iconify';
import { useRouter } from '../../../hooks/use-router';
import UserQuickEditForm from '../QuickUpdateUser';
import useCommonDetails from '../../../hooks/useCommonDetails';
import { toast } from 'react-toastify';
import { visuallyHidden } from '@mui/utils';
import { alpha } from '@mui/material/styles';
import { LoadingButton } from '@mui/lab';
import { useLocation, useNavigate, useParams } from 'react-router';
import BulkShiftUpload from '../BulkShiftUpload';
import dayjs from 'dayjs';
import { GlobalSearchContext } from '../../../context/GlobalSearchContext';
import { styled } from '@mui/material/styles';
import FormControlLabel from '@mui/material/FormControlLabel';
import Switch, { SwitchProps } from '@mui/material/Switch';
import { useSearchParams } from 'react-router-dom';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import { green, red } from '@mui/material/colors';
import { color } from 'framer-motion';

interface Game {
  name: string;
  email: any;
  role: any;
  team: string;
  shift: any;
  // Add other relevant fields here
}

function TabPanel(props: any) {
  const { children, value, index, ...other } = props;

  return (
    <Box
      role="tabpanel"
      hidden={value !== index}
      id={`tabpanel-${index}`}
      aria-labelledby={`tab-${index}`}
      sx={{ p: 3 }}
      {...other}
    >
      {value === index && <Box>{children}</Box>}
    </Box>
  );
}

export default function UserTable() {
  const [tabIndex, setTabIndex] = React.useState(0);
  const [users, setUsers] = React.useState<any[]>([]);
  const {
    _searchQueryTag: sQueryTag,
    handleSearchChangeTag,
    debouncedQueryTag,
  }: any = React.useContext(GlobalSearchContext);
  const [loading, setLoading] = React.useState(false);
  const [userToDelete, setUserToDelete] = React.useState<string | null>(null);
  const [currentUser, setCurrentUser] = React.useState<any | null>(null); // Add state for current user
  const confirm = useBoolean();
  const quickEdit = useBoolean();
  const bulkShiftUpload = useBoolean();
  const shiftAssgin = useBoolean();
  const popover = usePopover();
  const router = useRouter();
  const userInfo = useCommonDetails();
  const [currentPage, setCurrentPage] = React.useState(1);
  const [totalPages, setTotalPages] = React.useState(10);
  const [totalCount, setTotalCount] = React.useState(0);
  const itemsPerPage = 10;
  const location = useLocation();
  const [_searchQuery, _setSearchQuery] = React.useState('');
  const [debouncedQuery, setDebouncedQuery] = React.useState(_searchQuery);
  const [orderBy, setOrderBy] = React.useState<any>(null);
  const [order, setOrder] = React.useState<any>(null);
  const [selected, setSelected] = React.useState<readonly number[]>([]);
  const navigate = useNavigate();
  const [teams, setTeams] = React.useState<any>([]);
  const [shifts, setShifts] = React.useState<any[]>([]);
  const [shiftData, setShiftData] = React.useState<any>('');
  const [selectShift, setSelectShift] = React.useState<any[]>([]);
  const [selectShiftId, setSelectShiftId] = React.useState<any[]>([]);
  const [selectedTeams, setSelectedTeams] = React.useState<any[]>([]);
  const [selectedTeamsKeys, setSelectedTeamsKeys] = React.useState<any[]>([]);
  const [selectedRoles, setSelectedRoles] = React.useState<any[]>([]);
  const [selectedRoleKeys, setSelectedRoleKeys] = React.useState<any[]>([]);
  const [loadingShift, setLodingShift] = React.useState(false);
  const [showCheckIn, setShowCheckIn] = React.useState(false);
  const [searchParams, setSearchPasarams] = useSearchParams();

  const [isRequestSwitch, setIsRequestSwitch] = React.useState<any>(false);
  const ids = searchParams.get('ids');

  const handleTabChange = (event: React.SyntheticEvent, newValue: number) => {
    setCurrentPage(1);
    setTabIndex(newValue);
  };

  const handleChangeShowCheckIn = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    setShowCheckIn(event.target.checked);
  };

  const handleShiftChange = (event: SelectChangeEvent<typeof shiftData>) => {
    const {
      target: { value },
    } = event;
    setShiftData(value);
  };

  const fetchRequestAssingFlag = React.useCallback(async () => {
    try {
      setLoading(true);
      const response = await HttpService.get(API_ROUTES.requestButtonFlag);

      setIsRequestSwitch(response.data.data || []);
    } catch (error: any) {
      console.error('Error fetching shift list:', error);
    } finally {
      setLoading(false);
    }
  }, []);

  React.useEffect(() => {
    fetchRequestAssingFlag();
  }, [fetchRequestAssingFlag]);

  const assingRequestEnableDesible = async (nextChecked: boolean) => {
    try {
      setLoading(true);
      await HttpService.patch(API_ROUTES.autoAssign, {
        auto_assign: nextChecked,
      });
      await fetchRequestAssingFlag();
    } catch (error: any) {
      console.error('Error updating auto assign setting:', error);
    } finally {
      setLoading(false);
    }
  };

  const fetchShiftsList = React.useCallback(async () => {
    const query: any = {
      search: sQueryTag,
    };
    try {
      setLoading(true);
      const response = await HttpService.get(
        API_ROUTES.fatchShift + `?${new URLSearchParams(query).toString()}`
      );

      setShifts(response.data.data.list || []);
    } catch (error: any) {
      console.error('Error fetching shift list:', error);
    } finally {
      setLoading(false);
    }
  }, [sQueryTag]);

  React.useEffect(() => {
    fetchShiftsList();
  }, [fetchShiftsList]);

  const fetchTeamsList = React.useCallback(async () => {
    try {
      const response = await HttpService.get(API_ROUTES.fatchAllTeam);
      setTeams(response.data.data);
    } catch (error: any) {
      console.error('Error fetching teams list:', error);
    }
  }, []);

  // Call fetchTeamsList only once on component mount
  React.useEffect(() => {
    fetchTeamsList();
  }, [fetchTeamsList]);

  const handleChangeTeams = (event: any, newValue: any) => {
    setCurrentPage(1);
    setSelectedTeams(newValue);
    const selectedKeys = newValue.map((option: any) => option.id);
    setSelectedTeamsKeys(selectedKeys);
  };

  const handleChangeRole = (event: any, newValue: any) => {
    setCurrentPage(1);
    setSelectedRoles(newValue);
    const selectedKeys = newValue.map((option: { key: number }) => option.key);
    setSelectedRoleKeys(selectedKeys);
  };

  const handleSearchChange = (e: any) => {
    setDebouncedQuery(e.target.value);
  };

  React.useEffect(() => {
    const timer = setTimeout(() => _setSearchQuery(debouncedQuery), 500);
    return () => clearTimeout(timer);
  }, [debouncedQuery]);

  const handlePageChange = (
    event: React.ChangeEvent<unknown>,
    page: number
  ) => {
    setCurrentPage(page); // Update the current page
  };

  const handleChangeShift = (event: any, newValue: any) => {
    setCurrentPage(1);
    const newSelected = [...newValue.map((n: { id: any }) => n.id)];
    const uniqueSelected = Array.from(new Set(newSelected)); // Ensure no duplicates
    setSelectShift(newValue);
    setSelectShiftId(uniqueSelected);
  };
  const fetchUsersList = React.useCallback(async () => {
    const query: any = {
      search: _searchQuery,
      page: currentPage,
      limit: itemsPerPage,
      isTpeUser: tabIndex === 0 ? false : true,
    };
    if (orderBy && order) {
      (query.sortBy = orderBy), (query.orderBy = order);
    }
    if (selectedRoleKeys) {
      query.roleId = selectedRoleKeys.join(',');
    }
    if (selectedTeamsKeys.length > 0) {
      query.teamId = selectedTeamsKeys.join(',');
    }
    if (selectShiftId.length > 0) {
      query.shiftId = selectShiftId;
    }
    if (ids) {
      query.userIds = ids;
    }

    query.checkedIn = showCheckIn;

    try {
      setLoading(true);
      const response = await HttpService.get(
        API_ROUTES.allUser + `?${new URLSearchParams(query).toString()}`
      );
      setUsers(response.data.data.list || []);
      setTotalPages(response.data.data.totalPages);
      setTotalCount(response.data.data.totalCount);
    } catch (error: any) {
      console.error('Error fetching user list:', error);
    } finally {
      setLoading(false);
    }
  }, [
    selectedRoles,
    currentPage,
    itemsPerPage,
    showCheckIn,
    selectedTeams,
    _searchQuery,
    selectShift,
    tabIndex,
    order,
    ids,
  ]);

  React.useEffect(() => {
    fetchUsersList();
  }, [fetchUsersList]);

  // Function to delete a user
  const onDeleteRow = async () => {
    if (!userToDelete) return;

    try {
      setLoading(true);
      await HttpService.deleteData(API_ROUTES.deleteUser, userToDelete);
      setUsers((prevUsers: any) =>
        prevUsers.filter((user: any) => user.id !== userToDelete)
      );
      confirm.onFalse();
      fetchUsersList();
      toast.success('Delete User Successfully', {
        position: 'bottom-right',
      });
    } catch (error: any) {
      console.error('Error deleting user:', error);
      confirm.onFalse();
    } finally {
      setLoading(false);
      setUserToDelete(null); // Reset user to delete
    }
  };

  const addUser = () => {
    router.push(PAGE_ROUTES.ADDUSER);
  };

  const addTpeUser = () => {
    router.push(PAGE_ROUTES.ADDTPEUSER);
  };

  const clearFilter = () => {
    setSelectedRoleKeys([]);
    setSelectedTeamsKeys([]);
    setSelectedRoles([]);
    setSelectedTeams([]);
    setSelectShiftId([]);
    setSelectShift([]);
    setDebouncedQuery('');
    setShowCheckIn(false);
    navigate(PAGE_ROUTES.USERS);
    setCurrentPage(1);
  };
  const createSortHandler = (property: keyof Game) => () => {
    const isAsc = orderBy === property && order === 'asc';
    setOrder(isAsc ? 'desc' : 'asc');
    setOrderBy(property);
  };

  const handleSelectAllClick = (event: React.ChangeEvent<HTMLInputElement>) => {
    if (event.target.checked) {
      const newSelected = [...selected, ...users.map((n) => n.id)];
      const uniqueSelected = Array.from(new Set(newSelected)); // Ensure no duplicates
      setSelected(uniqueSelected);
      return;
    }
    setSelected([]);
  };
  const handleClick = (event: React.MouseEvent<unknown>, id: number) => {
    const selectedIndex = selected.indexOf(id);
    let newSelected: readonly number[] = [];

    if (selectedIndex === -1) {
      newSelected = newSelected.concat(selected, id);
    } else if (selectedIndex === 0) {
      newSelected = newSelected.concat(selected.slice(1));
    } else if (selectedIndex === selected.length - 1) {
      newSelected = newSelected.concat(selected.slice(0, -1));
    } else if (selectedIndex > 0) {
      newSelected = newSelected.concat(
        selected.slice(0, selectedIndex),
        selected.slice(selectedIndex + 1)
      );
    }
    setSelected(newSelected);
  };

  const assginShift = async () => {
    setLodingShift(true);
    const data = {
      shiftId: shiftData,
      userIds: selected,
    };
    try {
      const res = await HttpService.post(API_ROUTES.bulkAssginShift, data);
      fetchUsersList();
      toast.success(res.data.message, {
        position: 'bottom-right',
      });
      shiftAssgin.onFalse();
      setSelected([]);
      setShiftData('');
      setLodingShift(false);
    } catch (error) {
      console.log('Error during Clock In:', error);
      setLodingShift(false);
    }
  };

  const handleNavigateToUserUpdate = (userId: any) => {
    // Navigate to the UserDetailsUpdate page with the userId in the URL
    navigate(`/user-details-update/${userId}`);
  };

  const roleOptions = Object.entries(ROLE_MAP_filter).map(([key, value]) => ({
    key: Number(key),
    label: value,
  }));
  const IOSSwitch = styled((props: SwitchProps) => (
    <Switch
      focusVisibleClassName=".Mui-focusVisible"
      disableRipple
      {...props}
    />
  ))(({ theme }) => ({
    width: 42,
    height: 26,
    padding: 0,
    '& .MuiSwitch-switchBase': {
      padding: 0,
      margin: 2,
      transitionDuration: '300ms',
      '&.Mui-checked': {
        transform: 'translateX(16px)',
        color: '#fff',
        '& + .MuiSwitch-track': {
          backgroundColor: '#1976D2',
          opacity: 1,
          border: 0,
          ...theme.applyStyles('dark', {
            backgroundColor: '#2ECA45',
          }),
        },
        '&.Mui-disabled + .MuiSwitch-track': {
          opacity: 0.5,
        },
      },
      '&.Mui-focusVisible .MuiSwitch-thumb': {
        color: '#33cf4d',
        border: '6px solid #fff',
      },
      '&.Mui-disabled .MuiSwitch-thumb': {
        color: theme.palette.grey[100],
        ...theme.applyStyles('dark', {
          color: theme.palette.grey[600],
        }),
      },
      '&.Mui-disabled + .MuiSwitch-track': {
        opacity: 0.7,
        ...theme.applyStyles('dark', {
          opacity: 0.3,
        }),
      },
    },
    '& .MuiSwitch-thumb': {
      boxSizing: 'border-box',
      width: 22,
      height: 22,
    },
    '& .MuiSwitch-track': {
      borderRadius: 26 / 2,
      backgroundColor: '#E9E9EA',
      opacity: 1,
      transition: theme.transitions.create(['background-color'], {
        duration: 500,
      }),
      ...theme.applyStyles('dark', {
        backgroundColor: '#39393D',
      }),
    },
  }));

  interface EnhancedTableToolbarProps {
    numSelected: number;
  }

  function EnhancedTableToolbar(props: EnhancedTableToolbarProps) {
    const { numSelected } = props;
    return (
      <Toolbar
        sx={[
          {
            pl: { sm: 2 },
            pr: { xs: 1, sm: 1 },
          },
          numSelected > 0 && {
            bgcolor: (theme) =>
              alpha(
                theme.palette.primary.main,
                theme.palette.action.activatedOpacity
              ),
          },
        ]}
      >
        {numSelected > 0 && (
          <Typography
            sx={{ flex: '1 1 100%' }}
            color="inherit"
            variant="subtitle1"
            component="div"
          >
            {numSelected} selected
          </Typography>
        )}
        {numSelected > 0 && (
          <Tooltip title="Assgin Shift">
            <IconButton
              onClick={() => {
                shiftAssgin.onTrue();
                popover.onClose();
              }}
            >
              <Iconify icon="fluent:shifts-add-24-filled" width={25} />
            </IconButton>
          </Tooltip>
        )}
      </Toolbar>
    );
  }
  interface EnhancedTableProps {
    numSelected: number;
    onSelectAllClick: (event: React.ChangeEvent<HTMLInputElement>) => void;
    rowCount: number;
  }

  function EnhancedTableHead(props: EnhancedTableProps) {
    const { onSelectAllClick, numSelected, rowCount } = props;

    return (
      <TableHead>
        <TableRow>
          <TableCell padding="checkbox">
            <Checkbox
              color="primary"
              indeterminate={numSelected > 0 && numSelected < rowCount}
              checked={rowCount > 0 && numSelected === rowCount}
              onChange={onSelectAllClick}
              inputProps={{
                'aria-label': 'select all desserts',
              }}
            />
          </TableCell>
          <TableCell align="left">
            <TableSortLabel
              active={orderBy === 'name'}
              direction={orderBy === 'name' ? order : 'asc'}
              onClick={createSortHandler('name')}
            >
              Name
              {orderBy === 'name' ? (
                <Box component="span" sx={visuallyHidden}>
                  {order === 'desc' ? 'sorted descending' : 'sorted ascending'}
                </Box>
              ) : null}
            </TableSortLabel>
          </TableCell>
          {tabIndex === 1 && <TableCell align="left">TMS Id</TableCell>}
          {tabIndex === 1 && <TableCell align="left">TPE Id</TableCell>}
          {tabIndex === 1 && <TableCell align="left">TPE Email</TableCell>}
          <TableCell align="left">
            <TableSortLabel
              active={orderBy === 'email'}
              direction={orderBy === 'email' ? order : 'asc'}
              onClick={createSortHandler('email')}
            >
              TMS Email
              {orderBy === 'email' ? (
                <Box component="span" sx={visuallyHidden}>
                  {order === 'desc' ? 'sorted descending' : 'sorted ascending'}
                </Box>
              ) : null}
            </TableSortLabel>
          </TableCell>
          <TableCell align="left">
            <TableSortLabel
              active={orderBy === 'team'}
              direction={orderBy === 'team' ? order : 'asc'}
              onClick={createSortHandler('team')}
            >
              Team
              {orderBy === 'team' ? (
                <Box component="span" sx={visuallyHidden}>
                  {order === 'desc' ? 'sorted descending' : 'sorted ascending'}
                </Box>
              ) : null}
            </TableSortLabel>
          </TableCell>
          <TableCell align="left">
            <TableSortLabel
              active={orderBy === 'shift'}
              direction={orderBy === 'shift' ? order : 'asc'}
              onClick={createSortHandler('shift')}
            >
              Shift
              {orderBy === 'shift' ? (
                <Box component="span" sx={visuallyHidden}>
                  {order === 'desc' ? 'sorted descending' : 'sorted ascending'}
                </Box>
              ) : null}
            </TableSortLabel>
          </TableCell>
          <TableCell align="left">
            <TableSortLabel
              active={orderBy === 'role'}
              direction={orderBy === 'role' ? order : 'asc'}
              onClick={createSortHandler('role')}
            >
              Role
              {orderBy === 'role' ? (
                <Box component="span" sx={visuallyHidden}>
                  {order === 'desc' ? 'sorted descending' : 'sorted ascending'}
                </Box>
              ) : null}
            </TableSortLabel>
          </TableCell>

          <TableCell align="left">IP Address</TableCell>
          <TableCell align="left">Email Verified</TableCell>
          {/* <TableCell align="left">Disabled</TableCell> */}
          <TableCell align="left">Action</TableCell>
        </TableRow>
      </TableHead>
    );
  }
  function EnhancedTableRow(props: any) {
    const { isItemSelected, row, labelId } = props;
    return (
      <TableRow
        hover
        // onClick={(event) => handleClick(event, row.id)}
        role="checkbox"
        aria-checked={isItemSelected}
        tabIndex={-1}
        key={row.id}
        selected={isItemSelected}
        sx={{ cursor: 'pointer' }}
      >
        <TableCell padding="checkbox">
          <Checkbox
            color="primary"
            onClick={(event) => handleClick(event, row.id)}
            checked={isItemSelected}
            inputProps={{
              'aria-labelledby': labelId,
            }}
          />
        </TableCell>
        <TableCell sx={{ '&:hover': { color: 'orange', cursor: 'pointer' } }}>
          <Box
            sx={{
              display: 'flex',
              gap: 1,
              alignItems: 'center',
            }}
          >
            {row?.isWorking === 1 && (
              <Box
                sx={{
                  height: '15px',
                  width: '15px',
                  borderRadius: '15px',
                  color: 'lightgreen',
                  backgroundColor: 'lightgreen',
                }}
              ></Box>
            )}
            {row?.name}
          </Box>
        </TableCell>
        {tabIndex === 1 && (
          <TableCell sx={{ '&:hover': { color: 'orange', cursor: 'pointer' } }}>
            {row?.tpe_users?.[0]?.tms_id || '-'}
          </TableCell>
        )}
        {tabIndex === 1 && (
          <TableCell sx={{ '&:hover': { color: 'orange', cursor: 'pointer' } }}>
            {row?.tpe_users?.[0]?.tpe_id || '-'}
          </TableCell>
        )}
        {tabIndex === 1 && (
          <TableCell sx={{ '&:hover': { color: 'orange', cursor: 'pointer' } }}>
            {row?.tpe_users?.[0]?.user_email || '-'}
          </TableCell>
        )}
        <TableCell sx={{ '&:hover': { color: 'orange', cursor: 'pointer' } }}>
          {row?.email}
        </TableCell>
        <TableCell sx={{ '&:hover': { color: 'orange', cursor: 'pointer' } }}>
          {row?.team?.userTeamKey}
        </TableCell>
        <TableCell sx={{ '&:hover': { color: 'orange', cursor: 'pointer' } }}>
          {row?.shift?.shiftName}
        </TableCell>
        <TableCell sx={{ padding: '0px', paddingLeft: '7px' }}>
          {row?.role?.roleName}
        </TableCell>
        <TableCell sx={{ padding: '0px', paddingLeft: '7px' }}>
          {row?.ipAddress}
        </TableCell>
        <TableCell sx={{ padding: '0px', paddingLeft: '7px' }}>
          {row?.isEmailVerified ? (
            <Iconify icon="ic:round-check-circle" style={{ color: 'green' }} />
          ) : (
            <Iconify icon="ic:baseline-cancel" style={{ color: 'red' }} />
          )}
        </TableCell>
        <TableCell
          align="left"
          sx={{ margin: '0', padding: '0', whiteSpace: 'nowrap' }}
        >
          <Tooltip title="Update User Details" placement="top" arrow>
            <IconButton
              onClick={() => {
                handleNavigateToUserUpdate(row.id); // Set the current user for quick edit
              }}
            >
              <Iconify icon="flowbite:eye-solid" />
            </IconButton>
          </Tooltip>

          <Tooltip title="Reset Password" placement="top" arrow>
            <IconButton
              onClick={() => {
                setCurrentUser(row); // Set the current user for quick edit
                quickEdit.onTrue();
                popover.onClose();
              }}
              sx={{ color: quickEdit.value ? 'inherit' : 'default' }}
            >
              <Iconify icon="mdi:password-reset" />
            </IconButton>
          </Tooltip>

          {/* Delete button: disable if userInfo.userId matches row.uid */}
          <Tooltip title="Delete" placement="top" arrow>
            <span>
              {' '}
              {/* Wrapping in <span> to handle disabled tooltip */}
              <IconButton
                onClick={() => {
                  setUserToDelete(row.id); // Set the user ID to delete
                  confirm.onTrue(); // Open confirmation dialog
                  popover.onClose();
                }}
                sx={{ color: 'error.main' }}
                disabled={userInfo.userId === row.id} // Disable the button if userId matches
              >
                <Iconify icon="solar:trash-bin-trash-bold" />
              </IconButton>
            </span>
          </Tooltip>
        </TableCell>
      </TableRow>
    );
  }
  const EnhancedTable = () => {
    return (
      <>
        <TableContainer component={Paper}>
          <Table aria-label="collapsible table">
            <EnhancedTableHead
              numSelected={selected.length}
              onSelectAllClick={handleSelectAllClick}
              rowCount={totalCount}
            />
            <TableBody>
              {(users || []).map((row: any, index: any) => {
                const isItemSelected = selected.includes(row.id);
                const labelId = `enhanced-table-checkbox-${index}`;

                return (
                  <EnhancedTableRow
                    isItemSelected={isItemSelected}
                    row={row}
                    labelId={labelId}
                  />
                );
              })}
            </TableBody>
          </Table>
        </TableContainer>
      </>
    );
  };
  return (
    <>
      <Box sx={{ display: 'block' }}></Box>
      <Box
        sx={{
          display: 'flex',
          padding: '20px 0',
          justifyContent: 'space-between',
          gap: 2,
          flexWrap: 'wrap',
        }}
      >
        <Box sx={{ display: 'flex', gap: 2, flexWrap: 'wrap' }}>
          <TextField
            variant="outlined"
            size="small"
            placeholder="Search..."
            value={debouncedQuery}
            onChange={handleSearchChange}
            sx={{ width: '300px', height: '2.4375em !important' }} // Adjust the width as needed
          />
          <FormControl sx={{ minWidth: 200 }}>
            <Autocomplete
              size="small"
              multiple
              fullWidth
              id="role-selector"
              options={roleOptions}
              value={selectedRoles} // Replace with your selected roles state
              getOptionLabel={(option) => option.label}
              onChange={(event, newValue) => {
                handleChangeRole(event, newValue); // Replace with your role change handler
              }}
              filterSelectedOptions
              renderInput={(params) => (
                <TextField {...params} placeholder="Select Role" />
              )}
              isOptionEqualToValue={(option, value) => option.key === value.key}
            />
          </FormControl>
          <FormControl sx={{ minWidth: 200 }}>
            <Autocomplete
              size="small"
              multiple
              fullWidth
              id="role-selector"
              options={teams}
              value={selectedTeams} // Replace with your selected roles state
              getOptionLabel={(option: any) => option.userTeamKey}
              onChange={(event, newValue) => {
                handleChangeTeams(event, newValue); // Replace with your role change handler
              }}
              filterSelectedOptions
              renderInput={(params) => (
                <TextField {...params} placeholder="Select Teams" />
              )}
              isOptionEqualToValue={(option, value) => option.id === value.id}
            />
          </FormControl>
          <FormControl sx={{ minWidth: 200 }}>
            <Autocomplete
              size="small"
              multiple
              fullWidth
              id="disable-clearable"
              options={shifts}
              value={selectShift}
              isOptionEqualToValue={(option, value) => option.id === value?.id}
              getOptionLabel={(option) => option.shiftName || 'Unknown Shift'} // Ensure string is displayed
              renderOption={(props, option) => (
                <Box component="li" {...props} key={option?.id}>
                  <Typography
                    variant="body1"
                    sx={{ fontStyle: 'normal', textTransform: 'none' }}
                  >
                    {option?.shiftName || 'Unknown Shift'}
                  </Typography>
                </Box>
              )}
              onClose={() => {
                const data = {
                  target: {
                    value: '',
                  },
                };
                handleSearchChangeTag(data);
              }}
              onChange={(event, newValue) => {
                handleChangeShift(event, newValue);
              }}
              renderInput={(params) => (
                <TextField
                  {...params}
                  value={debouncedQueryTag || ''} // Ensure value is a string
                  onChange={(e) => handleSearchChangeTag(e)}
                  placeholder="Select Shift"
                />
              )}
            />
          </FormControl>

          <FormControlLabel
            control={
              <IOSSwitch
                sx={{ m: 1 }}
                checked={showCheckIn}
                onChange={(e) => {
                  handleChangeShowCheckIn(e);
                  setCurrentPage(1);
                }}
              />
            }
            label="Active Users"
          />

          {isRequestSwitch?.isSettingEnable && (
            <FormControlLabel
              control={
                <IOSSwitch
                  sx={{ m: 1 }}
                  checked={isRequestSwitch?.autoAssignTagging}
                  onChange={(e) => {
                    assingRequestEnableDesible(e.target.checked);
                    setCurrentPage(1);
                  }}
                />
              }
              label="Request Auto Assign"
            />
          )}
          <Box>
            <Button
              onClick={() => clearFilter()}
              variant="contained"
              sx={{ textTransform: 'none', whiteSpace: 'nowrap' }}
            >
              Clear Filter
            </Button>
          </Box>
        </Box>
        <Box
          sx={{
            display: 'flex',
            flexDirection: { md: 'column', lg: 'row' },
            gap: 1,
          }}
        >
          <Box>
            <Button
              variant="contained"
              onClick={() => {
                bulkShiftUpload.onTrue();
                popover.onClose();
              }}
              sx={{ textTransform: 'none', whiteSpace: 'nowrap' }}
            >
              Bulk Shift Update
            </Button>
          </Box>
          <Box>
            {' '}
            <Button
              variant="contained"
              onClick={addUser}
              sx={{ textTransform: 'none', whiteSpace: 'nowrap' }}
            >
              Add User
            </Button>
          </Box>
          <Box>
            {' '}
            <Button
              variant="contained"
              onClick={addTpeUser}
              sx={{ textTransform: 'none', whiteSpace: 'nowrap' }}
            >
              Add TPE User
            </Button>
          </Box>
        </Box>
      </Box>
      <EnhancedTableToolbar numSelected={selected.length} />
      <Tabs
        value={tabIndex}
        onChange={handleTabChange}
        aria-label="Dashboard Tabs"
      >
        <Tab label="TMS Users" />
        <Tab label="TPE Users" />
      </Tabs>
      <TabPanel
        value={tabIndex}
        index={0}
        sx={
          {
            // padding: '0px !important',
            // margin: '0px !important',
          }
        }
      >
        <EnhancedTable />
      </TabPanel>
      <TabPanel
        value={tabIndex}
        index={1}
        sx={
          {
            // padding: '0px !important',
            // margin: '0px !important',
          }
        }
      >
        <EnhancedTable />
      </TabPanel>
      {/* Pagination Component */}
      <Box display="flex" justifyContent="center" my={2}>
        <Pagination
          count={totalPages} // Total number of pages
          page={currentPage} // Current page
          onChange={handlePageChange} // Handle page change
          color="primary"
        />
      </Box>
      <StatusDialog
        open={shiftAssgin.value}
        onClose={shiftAssgin.onFalse}
        fullWidth={true}
        title="Assgin Shift"
        content={
          <>
            {' '}
            <FormControl sx={{ flexShrink: 0, marginTop: 2 }} fullWidth>
              <InputLabel>Select Shift</InputLabel>
              <Select
                label="Select Shift"
                value={shiftData}
                onChange={handleShiftChange}
                MenuProps={{ PaperProps: { sx: { maxHeight: 240 } } }}
              >
                {shifts && shifts.length > 0 ? (
                  shifts.map((shift: any) => (
                    <MenuItem key={shift.id} value={shift.id}>
                      <span style={{ fontWeight: 'bolder' }}>
                        {shift.shiftName}
                      </span>{' '}
                      &nbsp; &nbsp; Start Time :{' '}
                      {dayjs(shift?.startTime).format('HH:mm') || '00:00'}{' '}
                      &nbsp; &nbsp; End Time :{' '}
                      {dayjs(shift?.endTime).format('HH:mm') || '00:00:00'}
                    </MenuItem>
                  ))
                ) : (
                  <MenuItem disabled>No Shift Found</MenuItem>
                )}
              </Select>
            </FormControl>
          </>
        }
        action={
          <LoadingButton
            variant="contained"
            color="success"
            loading={loadingShift}
            onClick={() => {
              assginShift();
              // comment.onFalse();
            }}
          >
            Assgin Shift
          </LoadingButton>
        }
      />

      <BulkShiftUpload
        open={bulkShiftUpload.value}
        onClose={bulkShiftUpload.onFalse}
        fetchUsersList={fetchUsersList}
      />
      {/* Pass selected user (currentUser) to UserQuickEditForm */}
      <UserQuickEditForm
        currentUser={currentUser} // Use currentUser state here
        open={quickEdit.value}
        onClose={quickEdit.onFalse}
      />

      {/* Confirm Dialog */}
      <ConfirmDialog
        open={confirm.value}
        onClose={confirm.onFalse}
        title="Delete"
        content="Are you sure you want to delete this user?"
        action={
          <Button
            variant="contained"
            color="error"
            onClick={onDeleteRow}
            sx={{ whiteSpace: 'nowrap' }}
          >
            Delete
          </Button>
        }
      />

      {/* Backdrop with CircularProgress for loader */}
      <Backdrop
        sx={(theme) => ({ color: '#fff', zIndex: theme.zIndex.drawer + 1 })}
        open={loading}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
    </>
  );
}
